export default "__VITE_ASSET__DQh97N0C__"